import { createRouter, createWebHistory } from "vue-router";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/",
      name: "home",
      component: () => import("@/views/PortfolioView.vue"),
    },
    {
      path: "/analysis",
      name: "analysis",
      component: () => import("@/views/PortfolioAnalysisView.vue"),
    },
    {
      path: "/risk",
      name: "risk",
      component: () => import("@/views/RiskView.vue"),
    },
    {
      path: "/holdings",
      name: "holdings",
      component: () => import("@/views/AllHoldingsView.vue"),
    },
    {
      path: "/mobile",
      name: "mobile",
      component: () => import("@/views/MobileView.vue"),
    },
    {
      path: "/feed",
      name: "feed",
      component: () => import("@/views/FeedView.vue"),
    },
    {
      path: "/signals",
      name: "signals",
      component: () => import("@/views/SignalsView.vue"),
    },
    {
      path: "/scenarios",
      name: "scenarios",
      component: () => import("@/views/ScenariosView.vue"),
    },
    {
      path: "/scenarios/:id",
      name: "scenario",
      component: () => import("@/views/ScenarioView.vue"),
    },
    {
      path: "/cashflow",
      name: "cashflow",
      component: () => import("@/views/InflowOutflowView.vue"),
    },
    {
      path: "/calendar",
      name: "calendar",
      component: () => import("@/views/CalendarView.vue"),
    },
    {
      path: "/macro",
      name: "macro",
      component: () => import("@/views/MacroView.vue"),
    },
    {
      path: "/comparison",
      name: "comparison",
      component: () => import("@/views/HoldingsComparisonView.vue"),
    },
    {
      path: "/isin/:isin",
      component: () => import("@/views/CompanyView.vue"),
    },
    {
      path: "/orders",
      component: () => import("@/views/OrdersView.vue"),
    },
    {
      path: "/orders-summary",
      component: () => import("@/views/OrdersSummaryView.vue"),
    },
    {
      path: "/returncontributions",
      component: () => import("@/views/ReturnContributionsView.vue"),
    },
    {
      path: "/management",
      component: () => import("@/views/StockManagementView.vue"),
    },
  ],
});

export default router;
